export default __webpack_public_path__ + "static/media/YahZarah.43835d1c.png";